import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { TasksStatusCardBase } from '@fi-shared/fi-task-shared/tasks-status/common-code/tasks-status-card-base';

@Component({
    selector: 'fi-tasks-status-completed',
    template: `
        <mat-card class="fi-content-card">
            <div class="fi-content-card-top fi-tasks-status-card-header">
                {{ 'task.status_completed_header' | fiAppText }}
            </div>
            <mat-card-content>
                <button
                    mat-flat-button
                    [disabled]="isActionDisabled()"
                    color="primary"
                    class="fi-tasks-status-action-button"
                    [matMenuTriggerFor]="taskActionMenu"
                >
                    <span>{{ 'common.with_selected' | fiAppText }}</span>
                    <span class="fas fa-chevron-down"></span>
                </button>

                <fi-wrapper-table
                    [items]="tasks"
                    [hasCheckedColumn]="true"
                    matSort
                    #sort="matSort"
                    [sort]="sort"
                    [checkedItems]="selectedTasks"
                    (checkedItemsChange)="selectedTasks = $event"
                >
                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                            <fi-wrapper-table-custom-sort-icon
                                sortIconType="string"
                                [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                                [headerLabel]="'task.task'"
                            >
                            </fi-wrapper-table-custom-sort-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ item.Name }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="CompletedByUserName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                            <fi-wrapper-table-custom-sort-icon
                                sortIconType="string"
                                [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                                [headerLabel]="'task.completed_by'"
                            >
                            </fi-wrapper-table-custom-sort-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ item.CompletedByUserName }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="CreatedOn">
                        <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                            <fi-wrapper-table-custom-sort-icon
                                sortIconType="number"
                                [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                                [headerLabel]="'common.start_date'"
                            >
                            </fi-wrapper-table-custom-sort-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ item.CreatedOn | fiFormatDate: 'date' }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="CompletedOn">
                        <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                            <fi-wrapper-table-custom-sort-icon
                                sortIconType="number"
                                [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                                [headerLabel]="'task.completed_date'"
                            >
                            </fi-wrapper-table-custom-sort-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ item.CompletedOn | fiFormatDate: 'date' }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="CompletionTime">
                        <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                            <fi-wrapper-table-custom-sort-icon
                                sortIconType="number"
                                [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                                [headerLabel]="'task.completion_time'"
                            >
                            </fi-wrapper-table-custom-sort-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ getCompletionTime(item) }} </mat-cell>
                    </ng-container>
                </fi-wrapper-table>
            </mat-card-content>
        </mat-card>
        <mat-menu #taskActionMenu>
            @for (action of taskActionItems; track action) {
                <button
                    mat-menu-item
                    (click)="action.onClick()"
                    [disabled]="isActionDisabled()"
                    [attr.aria-label]="action.title"
                >
                    <span>{{ action.title }}</span>
                </button>
            }
        </mat-menu>
    `,
    styleUrls: ['./tasks-status-completed.component.scss', '../common-code/tasks-status-card-base.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-tasks-status-completed' },
    standalone: false,
})
export class TasksStatusCompletedComponent extends TasksStatusCardBase implements OnInit {
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.taskActionItems = [
            {
                title: this.appTextService.get('task.archive_tasks'),
                onClick: () => super.saveTaskArchived(true),
            },
            {
                title: this.appTextService.get('task.set_as_uncompleted'),
                onClick: () => super.saveTaskCompleted(false),
            },
        ];
    }

    getCompletionTime(task: ITask) {
        return this.taskHelperService.getTimeInDays(task.CompletionTime);
    }
}
